module.exports = __webpack_public_path__ + "img/pipeline-tracking-system.2b883265.jpg";